import { createSlice } from "@reduxjs/toolkit";

const initialRecoveryState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  totalPrice: 0,
  totalCountReseller: 0,
  totalPriceReseller: 0,
  totalFeeReseller: 0,
  generateNum: "",
  entities: null,
  meta: { total: 0 },
  links: null,
  currency: "IDR",
  total_price: null,
  lastError: null,
  recoveryForEdit: undefined,
  validInvoice: undefined,
  recoveryForExport: [],
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const recoverySlice = createSlice({
  name: "recovery",
  initialState: initialRecoveryState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    recoveryFetched: (state, action) => {
      const { entities, meta, links } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.meta = meta;
      state.links = links;
    },
    getAggregationRecovery: (state, action) => {
      const { entity } = action.payload;
      state.actionsLoading = false;
      state.listLoading = false;
      state.totalPrice = entity.total_price;
      state.error = null;
    },
    getValidInvoice: (state, action) => {
      const { validInvoice } = action.payload;
      state.actionsLoading = false;
      state.listLoading = false;
      state.validInvoice = validInvoice;
      state.error = null;
    },
    recoveryCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.recovery.push(action.payload.recovery);
    },
    recoveryDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.recovery.filter(
        (el) => el.recovery_id !== action.payload.id
      );
    },
    getRecovery: (state, action) => {
      state.actionsLoading = false;
      state.recoveryForEdit = action.payload.recoveryForEdit;
      state.error = null;
    },
    getExportRecovery: (state, action) => {
      state.actionsLoading = false;
      if (action.payload.recoveryForExport === undefined) {
        state.recoveryForExport = [];
      } else {
        state.recoveryForExport.push(action.payload.recoveryForExport);
      }
      state.error = null;
    },
    // updateProduct
    recoveryUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities.recovery = state.entities.recovery.map((entity) => {
        if (entity.recovery_id === action.payload.recovery.recovery_id) {
          return action.payload.recovery;
        }
        return entity;
      });
    },
    exportFetchedRecovery: (state, action) => {
      const { totalCount, export_data } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.export_data = export_data;
      state.totalCount = totalCount;
    },
  },
});
